import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

@Component({
    selector: "vsf-product-list-zoom-modal",
    templateUrl: "./product-list-zoom-modal.component.html",
    styleUrls: ["./product-list-zoom-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListZoomModalComponent {
    @Input() zoomedImage: string | null = null;
    @Output() close = new EventEmitter<void>();
}
